import styled from 'styled-components'

export const Heading = styled.div`
    flex-direction: column;
    align-items:center;
    padding-block:1rem;
`

export const Title = styled.p`
        font-size:2rem;
        margin-bottom:10px;
        font-weight:1000;
`
export const SubTitle = styled.p`
        font-size:1rem;
`


export const Button = styled.button`
    border:none;
    padding: 10px 25px;
    box-shadow:none;
    height:2.5rem;
    background:#000;
    color:#A0E000;
    margin:1rem;
    width: 250px;
    cursor:pointer;
    border-radius: 8px;
    font-weight: 700;
`

export const CustomForm = styled.form`
    display:flex;
    flex-direction:column;
    align-items:stretch;
    width: 100%;
`
export const Success = styled.div`
    height:3rem;
    width:3rem;
    border-radius:50%;
    background:var(--primary);
    color:var(--white);
    font-size:1.5rem;
    margin-top:4rem;
`
